import React, { useContext } from 'react';
import { GlobalDataContext } from '../GlobalDataContext';

// import { Notation } from "react-abc";

import RydNoteDurationImage from './widgets/RydNoteDurationImage';
import { Note, NoteDuration, Tone } from '../model/core';

function IntervalTable() {
    const globalData = useContext(GlobalDataContext);
    if (!globalData || globalData.loading) return <div>Loading...</div>;
    const intervals = globalData.data?.intervals;
    return (<div>
        <table>
            <thead>
                <td>Name</td>
                <td>Semitones</td>
            </thead>
            <tbody>
                {intervals?.map(i =>
                    <tr key={i.name}>
                        <td>{i.name}</td>
                        <td>{i.semitones}</td>
                    </tr>)}
            </tbody>
        </table>
    </div>)
}

function NotesTable() {

    const notes = Note.all();
    return (<div>
        <table>
            <thead>
                <td>NoteIndex</td>
                <td>Rep</td>
            </thead>
            <tbody>
                {notes.map(i =>
                    <tr key={i.index}>
                        <td>{i.index}</td>
                        <td>{i.getName()}</td>
                    </tr>)}
            </tbody>
        </table>
    </div>)
}

function TonesTable() {

    const tones = Tone.all();
    return (<div>
        <table>
            <thead>
                <td>ToneIndex</td>
                <td>Rep</td>
            </thead>
            <tbody>
                {tones.map(i =>
                    <tr key={i.index}>
                        <td>{i.index}</td>
                        <td>{i.getName()}</td>
                    </tr>)}
            </tbody>
        </table>
    </div>)
}

function NoteDurationsTable() {
    const globalData = useContext(GlobalDataContext);
    if (!globalData || globalData.loading) return <div>Loading...</div>;
    const noteDurations = globalData.data?.noteDurations;

    return (<>
        <div>
            <table>
                <thead>
                    <td>Name</td>
                    <td>Value</td>
                    <td>client size values</td>
                </thead>
                <tbody>
                    {noteDurations?.map((nd, i) =>
                        <tr key={i}>
                            <td>{nd.name}</td>
                            <td>{nd.value}</td>
                            <td>{(1 / nd.value) / (1 / 32.0)}</td>
                        </tr>)}
                </tbody>
            </table>
            <div>
                <h3>Notation</h3>
                <div style={{ backgroundColor: 'white', display: 'flex', flexDirection: 'column' }}>
                    <div style={{
                        outline: '1px solid red',
                        position: 'relative',
                        width: '17px',
                        height: '50px',
                        top: '77px',
                        left: '281px'
                    }} />
                    {/* <Notation notation={"z8 z4 z2 z z/2 z/4 z/8"} style={{ top: '0px' }} /> */}
                </div>
                <div style={{ backgroundColor: 'white', display: 'flex', flexDirection: 'column' }}>
                    {/* <Notation notation={"c8 c4 c2 c c/2 c/4 c/8"} /> */}
                </div>
            </div>
            <div>
                <h3>Note Duration Images</h3>
                <table>
                    <thead>
                        <td>Symbol</td>
                        <td>Image</td>
                    </thead>
                    <tbody>
                        <tr>
                            <td>whole</td>
                            <td><RydNoteDurationImage duration={NoteDuration.fromBackendValue('WHOLE')} /></td>
                        </tr>
                        <tr>
                            <td>half</td>
                            <td><RydNoteDurationImage duration={NoteDuration.fromBackendValue('HALF')} /></td>
                        </tr>
                        <tr>
                            <td>4th</td>
                            <td><RydNoteDurationImage duration={NoteDuration.fromBackendValue('QUARTER')} /></td>
                        </tr>
                        <tr>
                            <td>8th</td>
                            <td><RydNoteDurationImage duration={NoteDuration.fromBackendValue('EIGHTH')} /></td>
                        </tr>
                        <tr>
                            <td>16th</td>
                            <td><RydNoteDurationImage duration={NoteDuration.fromBackendValue('SIXTEENTH')} /></td>
                        </tr>
                        <tr>
                            <td>32nd</td>
                            <td><RydNoteDurationImage duration={NoteDuration.fromBackendValue('THIRTY_SECOND')} /></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </>);
}

export default IntervalTable;
export {
    IntervalTable,
    NotesTable,
    TonesTable,
    NoteDurationsTable
};